import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.JFRT,
  displayName: "Artifactory",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "jpd-icon",
    title: "Platform",
    valueTransformer: (value) => value,
    valueTransformerSH: (value) => {
      return { display: value !== "N/A", value: value };
    },
  },
};

export default entitlement;
